<template>
	<div class="group-search-wrapper">
		<div id="groupSearchBox">
			<input
				id="groupSearch"
				ref="groupSearch"
				type="text"
				:placeholder="$t('contacts_userpicker_search_placeholder')"
				tabindex="1"
				class="standard-box"
				style="width: 100%;"
				v-model="searchText"
			/>
		</div>

		<div v-show="!showSpinner">
			<ul class="group-search-list" v-bind:style="{ maxHeight: maxHeight() }">
				<li
					v-for="group in groupsToRender"
					:key="group.id"
					class="group-item pointer"
					:class="{
						'disabled-group': group.is_supergroup || !canAssignTask(group),
					}"
					@click="selectGroup(group)"
				>
					<div class="group-search-title" v-text="group.displayname" />
					<div class="group-super-label" v-if="group.is_supergroup">
						{{ $t('chat_super_title') }}
					</div>

					<Tippy
						v-if="!canAssignTask(group)"
						arrow
						theme="large"
						:content="$t('tasks_no_permission')"
						:options="{ animation: 'scale' }"
						class="disabled-tooltip"
					>
						<CircleQuestionIcon regular class="help-icon" />
					</Tippy>
				</li>
			</ul>
		</div>

		<IosSpinner v-if="showSpinner" top="47%" left="calc(49vw - 125px)">
			<template #title>{{ loadingText }}</template>
		</IosSpinner>

		<div v-if="noResults" style="font-family: Avenir-Medium; color: #8a8d93;">
			{{ $t('common_loader_noresults_title') }}
		</div>
	</div>
</template>

<script>
import store, { getGroupChats, sortChatsByDisplayName } from '@/store'
import { Tippy, showAlertModal } from '@/components/common'
import { CircleQuestionIcon } from '@/icons'
import { chatCan, ASSIGN_TASK } from '@/helpers/permissions'
import IosSpinner from '@/components/IosSpinner'

export default {
	components: { Tippy, CircleQuestionIcon, IosSpinner },
	props: ['config'],
	data() {
		return {
			store,
			searchText: '',
			showSpinner: false,
			groupList: [],
			loadingText: '',
		}
	},

	emits: ['selectedGroup'],

	mounted() {
		this.getGroups()
		this.$refs.groupSearch.focus()
	},

	methods: {
		getGroups() {
			this.loadingText = this.$t('common_loader_loading_title')
			this.showSpinner = true
			this.groupList = getGroupChats().sort(sortChatsByDisplayName)
			this.showSpinner = false
		},

		maxHeight() {
			if (this.config.maxheight) {
				return 'calc(' + this.config.maxheight + ' - 78px'
			}
		},

		selectGroup(group) {
			if (group.is_supergroup) {
				showAlertModal({
					title: this.$t('common_no_permission'),
					description: this.$t('tasks_supergroup_assign_error'),
					danger: false,
				})
				return false
			}
			if (!this.canAssignTask(group)) return
			this.$emit('selectedGroup', group)
		},

		canAssignTask(group) {
			return chatCan(group, ASSIGN_TASK)
		},
	},

	computed: {
		groupsToRender() {
			if (!this.searchText) return this.groupList
			const regex = new RegExp(this.searchText, 'i')
			return this.groupList.filter((g) => regex.test(g.displayname))
		},
		noResults() {
			return this.groupsToRender.length === 0
		},
	},
}
</script>

<style lang="scss">
@import 'src/sass/variables';

.group-search-wrapper {
	width: 100%;
	height: 100%;
}

.group-search-modal {
	padding: 0 30px 0px 30px;
	height: 100%;
	overflow: hidden;
	width: 100%;
}

.group-search-list {
	list-style: none;
	padding: 0;
	margin: 15px auto;
	overflow-y: auto;
	li {
		@include flex-spread;
		width: 100%;
		height: 70px;
		border-bottom: 1px solid var(--neutral-40040);
		&:last-child {
			margin-bottom: 0px;
		}
		&:hover {
			&:not(.disabled-group) {
				.group-search-title {
					color: var(--teal-300);
				}
			}
		}
		&.disabled-group {
			cursor: not-allowed;
			.group-search-title,
			.group-super-label {
				opacity: 0.5;
			}
		}
		.group-search-title {
			flex-grow: 1;
			@include ellipsis;
			color: var(--neutral-800);
		}
		.help-icon {
			font-size: 20px;
			color: var(--neutral-300);
			cursor: pointer;
			&:hover {
				color: var(--teal-300);
				cursor: pointer;
			}
		}
	}
}
#groupSearchBox {
	padding: 0.5rem 0.5rem 0.75rem 16px;
	border: 1px solid #919193;
	border-radius: 0.25rem;
	cursor: text;
	font-size: 18px;
	line-height: 1.5rem;
	max-width: 100%;
	min-height: 61px;
}

#groupSearch {
	margin: 0.25rem 6px 0 0;
	height: 36px;
	line-height: 36px;
	border: none;
	-webkit-box-shadow: none;
	box-shadow: none;
	width: 150px;
	padding: 0;
	font-family: Avenir-Medium;
	font-size: 18px;
	outline: 0;
}
</style>
